import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { GenesisUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-confirmation-message-dialog',
    templateUrl: './confirmation-message-dialog.component.html',
    styleUrls: ['./confirmation-message-dialog.component.scss'],
    standalone: false
})
export class ConfirmationMessageDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    message: any;

    processing = false;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork) {}

    async ngOnInit() {
        if (!!this.message) {
        } else {
            this.message = this.uow.confirmationMessages.createEntity();
            this.message.created = new Date();
        }
    }

    async save() {
        this.processing = true;
        this.result.next({ success: true });
    }

    close() {
        this.processing = true;
        this.result.next(false);
    }
}
